import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { CTACard, ItemsList } from "@parkschannel/ui";
export const CTAList = (param)=>{
    let { data , renderImage  } = param;
    return /*#__PURE__*/ _jsx(ItemsList, {
        className: "w-full flex overflow-x-auto gap-[20px] pb-4 md:gap-8 lg:gap-12",
        items: data,
        renderItem: (cta)=>/*#__PURE__*/ _jsx(CTACard, {
                data: cta,
                renderImage: renderImage
            })
    });
};
